'use client';
import { useState } from 'react';
import { Image, ValImage } from '@valbuild/next';
import classNames from 'classnames';

interface HotspotImageProps {
  image: Image;
  clickable?: boolean;
  setAspectRatio?: string | null;
  className?: string;
  alt?: string;
  priority?: boolean;
  sizes?: string;
}

const HotspotImage = ({
  image,
  alt,
  clickable,
  setAspectRatio = null,
  className,
  priority = false,
  sizes = '1200px',
}: HotspotImageProps) => {
  const [clicked, setClicked] = useState<boolean>(false);

  const handleImageClose = () => {
    setClicked(false);
    document.body.style.overflow = 'auto';
  };

  const handleImageClick = () => {
    if (!clickable) return;
    setClicked(true);
    document.body.style.overflow = 'hidden';
  };

  const containerClasses = classNames(
    'relative w-full overflow-hidden',
    setAspectRatio,
    className
  );

  return (
    <>
      {clickable && clicked && (
        <div
          className="fixed top-0 left-0 z-50 w-screen h-screen bg-black bg-opacity-90"
          onClick={handleImageClose}
        >
          <div className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] flex justify-center">
            <div className="p-8 box-border w-[90vw] h-[90vh] relative">
              <ValImage
                className={'object-contain'}
                src={image}
                alt={alt || image?.alt || 'Bilde'}
                fill
                sizes={sizes}
                priority={priority}
              />
            </div>
          </div>
        </div>
      )}
      {setAspectRatio === null ? (
        // Unspecified aspect ratio, image determines container height
        <ValImage
          onClick={handleImageClick}
          className={classNames('w-full h-auto', className)}
          src={image}
          alt={alt || image?.alt || 'Bilde'}
          width={image?.width || 1200}
          height={image?.height || 800}
          sizes={sizes}
          priority={priority}
        />
      ) : (
        // Fixed aspect ratio, fill container (aspect ratio set in containerClasses)
        <div className={containerClasses}>
          <ValImage
            onClick={handleImageClick}
            className={'object-cover'}
            src={image}
            alt={alt || image?.alt || 'Bilde'}
            fill
            sizes={sizes}
            priority={priority}
          />
        </div>
      )}
    </>
  );
};

export default HotspotImage;
